export default __webpack_public_path__ + "static/media/logo.cdf0de71.svg";